import { render, staticRenderFns } from "./SidebarBadge.vue?vue&type=template&id=6b83b50c&scoped=true&"
import script from "./SidebarBadge.vue?vue&type=script&lang=js&"
export * from "./SidebarBadge.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBadge.vue?vue&type=style&index=0&id=6b83b50c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83b50c",
  null
  
)

export default component.exports